<template>
  <v-alert
    dense
    outlined
    :type="type"
    class="ma-0"
    :class="alertClass"
  >
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'info'
    },
    text: {
      type: String,
      default: ''
    },
    alertClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>